if (!customElements.get('caltiora-sold-out-alternative')) {
  customElements.define('caltiora-sold-out-alternative', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const scope = this.closest('.shopify-section');
      const options = { signal: this.controller.signal };
      scope?.addEventListener('variant:selected', () => { this.hidden = true; }, options);
      scope?.addEventListener('variant:update', (event) => {
        if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
        const incoming = event.detail?.data?.html?.querySelector(`caltiora-sold-out-alternative[data-product-id="${this.dataset.productId}"]`);
        if (!incoming) { this.hidden = true; return; }
        this.innerHTML = incoming.innerHTML;
        this.hidden = incoming.hidden;
      }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
